/**
 * @fileoverview contains utils related specifically to the release, rollout, and migration of input management.
 * This includes handling of feature flags and deprecation of features.
 */

import { atom } from 'recoil';
import { validateSetEffect } from '../../../effects/validateSetEffect';
import { resetOnStudioReset } from '../../../effects/signalEffects';

export const INPUT_MANAGEMENT_VERSIONS = [1, 2] as const;
export type INPUT_MANAGEMENT_VERSION = (typeof INPUT_MANAGEMENT_VERSIONS)[number];

/**
 * Which version of input management is used by the current view. Retrieved from the backend on load and set on creation for a new view.
 *
 * This atom MUST take into account experiment flags (e.g. new_studio_input_management_ff) when being set for newly created views.
 */
export const viewInputManagementVersion = atom<INPUT_MANAGEMENT_VERSION>({
  key: 'viewInputManagementVersion',
  effects: [
    validateSetEffect((newValue) => (INPUT_MANAGEMENT_VERSIONS.includes(newValue) ? '' : 'invalid version')),
    resetOnStudioReset,
  ],
});
